/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Getting_Started__Answer_2Inputs */

const en_help_center__getting_started__answer_2 = /** @type {((inputs: Help_Center__Getting_Started__Answer_2Inputs) => LocalizedString) & { parts: (inputs: Help_Center__Getting_Started__Answer_2Inputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Help_Center__Getting_Started__Answer_2Inputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`1. Browse available battles on the homepage2. Click on a product you'd like to win3. Pay the entry price (ranges from €30-€100)4. Purchase a bid package (we recommend starting with Bronze or Silver)5. Wait for the battle to fill and go live, then start bidding!`)
		}),
		{
			parts: /** @type {(inputs: Help_Center__Getting_Started__Answer_2Inputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "1. Browse available battles on the homepage" }, { type: "markup-standalone", name: "br", options: {}, attributes: {} }, { type: "text", value: "2. Click on a product you'd like to win" }, { type: "markup-standalone", name: "br", options: {}, attributes: {} }, { type: "text", value: "3. Pay the entry price (ranges from €30-€100)" }, { type: "markup-standalone", name: "br", options: {}, attributes: {} }, { type: "text", value: "4. Purchase a bid package (we recommend starting with Bronze or Silver)" }, { type: "markup-standalone", name: "br", options: {}, attributes: {} }, { type: "text", value: "5. Wait for the battle to fill and go live, then start bidding!" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "1. Browse available battles on the homepage2. Click on a product you'd like to win3. Pay the entry price (ranges from €30-€100)4. Purchase a bid package (we ..." |
*
* @param {Help_Center__Getting_Started__Answer_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__getting_started__answer_2 = /** @type {((inputs?: Help_Center__Getting_Started__Answer_2Inputs, options?: { locale?: "en" }) => LocalizedString) & { parts: (inputs?: Help_Center__Getting_Started__Answer_2Inputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Help_Center__Getting_Started__Answer_2Inputs, { locale?: "en" }, { br: { options: {}; attributes: {}; children: false } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Help_Center__Getting_Started__Answer_2Inputs, options?: { locale?: "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			return en_help_center__getting_started__answer_2(inputs)
		}),
		{
			parts: /** @type {(inputs?: Help_Center__Getting_Started__Answer_2Inputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				return typeof en_help_center__getting_started__answer_2.parts === "function" ? en_help_center__getting_started__answer_2.parts(inputs) : [{ type: "text", value: en_help_center__getting_started__answer_2(inputs) }]
			})
		}
	)
);